export enum AttachmentSource {
	Intake = 1,
	PreviousSection = 2,
	Investigation = 3,
}
